import { pickRandomHomeCarouselCars } from './pickRandomHomeCarouselCars';

export {
  pickRandomHomeCarouselCars,
  HOME_CAROUSEL_DISPLAY_COUNT,
} from './pickRandomHomeCarouselCars';

export function filterHomeCarsByCategory<T extends { category?: string | null }>(
  list: readonly T[],
  selectedCategory: string,
): T[] {
  if (selectedCategory === 'all') {
    return [...list];
  }
  const category = selectedCategory.toLowerCase();
  return list.filter(car => car.category?.toLowerCase() === category);
}

/** Stable key — carousel shuffle reruns only when car membership changes, not Apollo referential churn. */
export function homeCarouselCarsIdsKey(cars: readonly { id?: string | null }[]): string {
  if (cars.length === 0) {
    return '';
  }
  return cars
    .map(car => String(car.id ?? ''))
    .sort()
    .join('\0');
}

/**
 * Guest home Featured carousel: server already returns ≤8 via getFeaturedCars.
 * Host "My Car List" and below-fold monthly/hot sections may still call this —
 * guest monthly/hot: random sample up to 8; host: full list, no shuffle.
 */
export function homeCarouselDisplayCars<T extends { id?: string | null }>(
  cars: readonly T[],
  { isHost }: { isHost: boolean },
): T[] {
  if (isHost) {
    return [...cars];
  }
  return pickRandomHomeCarouselCars(cars);
}
